import { useState } from "react";
import { Button, CloseButton, Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useAppVersionWatcher from "@/shared/hooks/useAppVersionWatcher";

/**
 * 새 버전이 배포됐을 때 뜨는 안내. 페이지를 옮기면 자동으로 새로고침되므로(useAppVersionWatcher),
 * 이 배너는 한 화면에 오래 머무는 사용자를 위한 보조 수단이다. 닫으면 이 탭에서는 다시 띄우지 않는다.
 */
export default function AppVersionBanner() {
  const { hasNewVersion, reload } = useAppVersionWatcher();
  const [isDismissed, setIsDismissed] = useState(false);
  const { t } = useI18nHelper();

  if (!hasNewVersion || isDismissed) {
    return null;
  }

  return (
    <Flex
      role={"status"}
      // 화면 중앙 상단 — 우하단에 두면 눈에 잘 안 띄어 새 버전을 한참 놓치기 쉽다.
      position={"fixed"}
      top={"16px"}
      left={"50%"}
      transform={"translateX(-50%)"}
      zIndex={1400}
      maxWidth={"calc(100vw - 32px)"}
      alignItems={"center"}
      gap={"12px"}
      padding={"10px 12px 10px 16px"}
      background={"#1A1A19"}
      color={"#FFFFFF"}
      borderRadius={"8px"}
      boxShadow={"0px 4px 12px rgba(0, 0, 0, 0.2)"}
      fontSize={"13px"}
    >
      <Text>{t("common:app_version.new_version_available")}</Text>
      <Button
        size={"sm"}
        flexShrink={0}
        background={"#FFFFFF"}
        color={"#1A1A19"}
        _hover={{ background: "#EFEFED" }}
        onClick={reload}
      >
        {t("common:app_version.reload")}
      </Button>
      <CloseButton
        size={"sm"}
        aria-label={t("common:app_version.dismiss")}
        onClick={() => setIsDismissed(true)}
      />
    </Flex>
  );
}
